import React from "react";
import styled from "styled-components";
import { Spin } from "antd";

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
`;

const LoadingPage = ({ size = "large" }) => {
  return (
    <LoadingWrapper>
      <Spin size={size} />
    </LoadingWrapper>
  );
};

export default LoadingPage;
